// extracted by mini-css-extract-plugin
export default {"container":"Container_container__MBtsO","min-height":"Container_min-height__poZbv","start":"Container_start__IRxsL","column":"Container_column__qHX+X"};